import { PROJECT_VARIANTS } from '../../constants';
import * as id8Actions from '../../redux/id8/id8Actions';
import * as consumerId8Actions from '../../redux/consumer/id8/consumerId8Actions';

const id8ActionsMapping = {
  modifyConcept: {
    [PROJECT_VARIANTS.ADMIN]: id8Actions.modifyConcept,
    [PROJECT_VARIANTS.CONSUMER]: consumerId8Actions.consumerModifyConcept,
  },
  customImage: {
    [PROJECT_VARIANTS.ADMIN]: id8Actions.customImage,
    [PROJECT_VARIANTS.CONSUMER]: consumerId8Actions.consumerCustomImage,
  },
  runAgain: {
    [PROJECT_VARIANTS.ADMIN]: id8Actions.runAgain,
    [PROJECT_VARIANTS.CONSUMER]: consumerId8Actions.consumerRunAgain,
  },
  getImages: {
    [PROJECT_VARIANTS.ADMIN]: id8Actions.getImages,
    [PROJECT_VARIANTS.CONSUMER]: consumerId8Actions.getConsumerImages,
  },
  likeImage: {
    [PROJECT_VARIANTS.ADMIN]: id8Actions.likeId8Image,
    [PROJECT_VARIANTS.CONSUMER]: consumerId8Actions.consumerLikeId8Image,
  },
  downloadImage: {
    [PROJECT_VARIANTS.ADMIN]: id8Actions.downloadId8Image,
    [PROJECT_VARIANTS.CONSUMER]: consumerId8Actions.consumerDownloadId8Image,
  },
  reviseImage: {
    [PROJECT_VARIANTS.ADMIN]: id8Actions.reviseImage,
    [PROJECT_VARIANTS.CONSUMER]: consumerId8Actions.consumerReviseImage,
  },
  getAdImages: {
    [PROJECT_VARIANTS.ADMIN]: id8Actions.getAdImages,
    [PROJECT_VARIANTS.CONSUMER]: consumerId8Actions.getConsumerAdImages,
  },
  recreateAd: {
    [PROJECT_VARIANTS.ADMIN]: id8Actions.recreateAd,
    [PROJECT_VARIANTS.CONSUMER]: consumerId8Actions.recreateAdConsumer,
  },
  runAgainAd: {
    [PROJECT_VARIANTS.ADMIN]: id8Actions.runAgainAd,
    [PROJECT_VARIANTS.CONSUMER]: consumerId8Actions.runAgainAdConsumer,
  },
  modifyAdConcept: {
    [PROJECT_VARIANTS.ADMIN]: id8Actions.modifyAdConcept,
    [PROJECT_VARIANTS.CONSUMER]: consumerId8Actions.modifyAdConceptConsumer,
  },
  getLikedImages: {
    // [PROJECT_VARIANTS.ADMIN]: id8Actions.getLikedImages,
    // [PROJECT_VARIANTS.CONSUMER]: consumerId8Actions.consumerGetLikedImages,
  },
};

export default id8ActionsMapping;
